function ThemeConfig() {
  const colorSchemeJson = localStorage.getItem("colorSchemeJson");

  const colorScheme = colorSchemeJson ? JSON.parse(colorSchemeJson) : {};

  const greenOne = colorScheme?.gaugeColor?.wedge4Color
    ? colorScheme?.gaugeColor?.wedge4Color
    : "#BCF033";
  const greenTwo = colorScheme?.gaugeColor?.wedge3Color
    ? colorScheme?.gaugeColor?.wedge3Color
    : "#83D70F";
  const greenThree = colorScheme?.gaugeColor?.wedge2Color
    ? colorScheme?.gaugeColor?.wedge2Color
    : "#44BC23";
  const greenFour = colorScheme?.gaugeColor?.wedge1Color
    ? colorScheme?.gaugeColor?.wedge1Color
    : "#039529";
  const hoverOneText = colorScheme?.primaryButtonTextColor
    ? colorScheme.primaryButtonTextColor
    : "#003D4C";
  const hoverOne = colorScheme?.primaryButtonColor
    ? colorScheme.primaryButtonColor
    : "#9bdf41";
  const hoverOneOther = colorScheme?.otherButtonColor
    ? colorScheme.otherButtonColor
    : "#ffffff";
  const hoverOneOtherText = colorScheme?.otherButtonTextColor
    ? colorScheme.otherButtonTextColor
    : "#003D4C";

  const textBlue = "#003D4C";
  const textGrey1 = "#607277";
  const textGrey2 = "#859AA0";
  const lineGrey = "#E6E6E6";
  const bgGrey1 = "#E6E6E6";
  const bgGrey2 = "#F0F2F0";
  const greyColorOne = "#607277";
  const heading1 = {
    color: `${textBlue}`,
    fontSize: "2.75rem",
  };
  const heading2 = {
    color: `${textBlue}`,
    fontSize: "1.5rem",
  };
  const heading3 = {
    color: `${hoverOneText}`,
    fontSize: "1rem",
  };
  const heading4 = {
    color: `${textBlue}`,
    lineHeight: 1.5,
    fontSize: "1rem",
  };

  const theme = {
    palette: {
      common: {
        greenOne: `${greenOne}`,
        greenTwo: `${greenTwo}`,
        greenThree: `${greenThree}`,
        greenFour: `${greenFour}`,
        textBlue: `${textBlue}`,
        textGrey1: `${textGrey1}`,
        textGrey2: `${textGrey2}`,
        lineGrey: `${lineGrey}`,
        bgGrey1: `${bgGrey1}`,
        bgGrey2: `${bgGrey2}`,
        greyColorOne: `${greyColorOne}`,
      },
      primary: {
        main: `${textBlue}`,
        hoverOneText: `${hoverOneText}`,
      },
      secondary: {
        main: `${greenTwo}`,
        hoverOneText: `${hoverOneText}`,
      },
    },
    components: {
      MuiButton: {
        variants: [
          {
            props: { variant: "filled" },
            style: {
              textTransform: "none",
              borderRadius: 10,
              color: `${hoverOneText}`,
              backgroundColor: `${hoverOne}`,
              fontFamily: "Lato-Bold",
              minWidth: 60,
              fontSize: "16px",
              letterSpacing: "0.4px",
              boxShadow:
                "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)",
              "&:hover": {
                backgroundColor: `${hoverOne} !important`,
                opacity: 0.8,
              },
              "&:active": {
                backgroundColor: `${hoverOne} !important`,
                boxShadow: "none",
                opacity: 0.8,
              },
            },
          },

          {
            props: { variant: "outline" },
            style: {
              textTransform: "none",
              borderRadius: 10,
              boxShadow: "none",
              color: `${hoverOneOtherText}`,
              backgroundColor: `${hoverOneOther}`,
              border: `1.3px solid ${greenThree}`,
              fontFamily: "Lato-Regular",
              minWidth: 60,
              fontSize: "16px",
              "&:hover": {
                backgroundColor: `rgba(0, 0, 0, 0.04) !important`,
                color: `${hoverOneOtherText} !important`,
                opacity: 0.8,
                borderWidth: 1.5,
              },
            },
          },
          {
            props: { variant: "large" },
            style: {
              textTransform: "uppercase",
              borderRadius: 10,
              color: `${hoverOneText}`,
              backgroundColor: `${hoverOne}`,
              fontFamily: "Lato-Bold",
              minWidth: 330,
              fontSize: "20px",
              boxShadow:
                "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)",
              "&:hover": {
                backgroundColor: `${hoverOne}  !important`,
                color: `${hoverOneText} !important`,
                opacity: 0.8,
                span: {
                  color: `${hoverOneText} !important`,
                },
              },
              "&:active": {
                boxShadow: "none",
                backgroundColor: `${hoverOne}`,
                opacity: 0.8,
                span: {
                  color: `${hoverOneText} !important`,
                },
              },
              span: {
                "&:hover": {
                  color: `${hoverOneText} !important`,
                },
              },
              "&.Mui-disabled": {
                backgroundColor: "#ffffff",
                color: "rgba(0, 0, 0, 0.26) !important",
              },
            },
          },
          {
            props: { variant: "largeOutline" },
            style: {
              textTransform: "uppercase",
              borderRadius: 10,
              border: `1px solid ${greenThree}`,
              color: `${hoverOneOtherText}`,
              backgroundColor: `${hoverOneOther}`,
              fontFamily: "Lato-Bold",
              minWidth: 330,
              fontSize: "20px",
              boxShadow: 1,
              "&:hover": {
                backgroundColor: `${hoverOneOther}`,
                opacity: 0.8,
              },
              "&:active": {
                boxShadow: "none",
                backgroundColor: `${hoverOne}`,
                opacity: 0.8,
              },
            },
          },
          {
            props: { variant: "text" },
            style: {
              textTransform: "uppercase",
              color: `${hoverOneOtherText}`,
              fontFamily: "Lato-Bold",
              minWidth: 330,
              fontSize: "20px",
              "&:hover": {
                textDecoration: "underline",
              },
              "&:active": {
                boxShadow: "none",
              },
            },
          },
        ],
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 20,
            boxShadow: "0 0 20px 0 rgba(0, 0, 0, 0.18)",
          },
        },
      },
      MuiInput: {
        styleOverrides: {
          root: {
            "&.Mui-disabled": {
              WebkitTextFillColor: `${textBlue}`,
              "&:before": {
                borderBottomStyle: "solid",
              },
            },
            "&:after": {
              borderColor: `${greenThree}`,
              borderWidth: "2px",
            },
            "&:before": {
              borderColor: `${greenThree}`,
              borderWidth: "2px",
            },
            "&:hover": {
              "&:not(.Mui-disabled):before": {
                borderColor: `${greenThree}`,
                borderWidth: "2px",
              },
            },
            color: `${textBlue}`,
            input: {
              "&.Mui-disabled": {
                // "WebkitTextFillColor": `${textBlue}`,
              },
            },
          },
        },
      },
      MuiSelect: {
        variants: [
          {
            props: { variant: "filled" },
            style: {
              borderBottom: `3px solid ${greenThree}`,
            },
          },
        ],
      },
      MuiTextField: {
        variants: [
          {
            props: { variant: "filled" },
            style: {
              borderBottom: `3px solid ${greenThree}`,
            },
          },
        ],
      },
      MuiFilledInput: {
        defaultProps: {
          disableUnderline: true,
        },
      },
    },
    typography: {
      fontFamily: [
        "Lato",
        "Lato-Regular",
        "Lato-Light",
        "Lato-Medium",
        "Lato-Semibold",
        "Lato-Bold",
        "Lato-SemiboldItalic",
        "Lato-BlackItalic",
        "Lato-Heavy",
      ].join(","),
      text1: {
        ...heading1,
        fontFamily: "Lato",
      },
      text2: {
        ...heading2,
        fontFamily: "Lato",
      },
      text3: {
        ...heading3,
        fontFamily: "Lato",
      },
      text4: {
        ...heading4,
        fontFamily: "Lato",
      },

      regularText1: {
        ...heading1,
        fontFamily: "Lato-Regular",
      },
      regularText2: {
        ...heading2,
        fontFamily: "Lato-Regular",
      },
      regularText3: {
        ...heading3,
        fontFamily: "Lato-Regular",
      },
      regularText4: {
        ...heading4,
        fontFamily: "Lato-Regular",
      },
      capitalText: {
        fontFamily: "Lato",
        fontSize: "2rem",
        letterSpacing: "1.08px",
        lineHeight: "2rem",
        textTransform: "uppercase",
        color: `${textBlue}`,
      },

      italicText: {
        fontStyle: "italic",
        color: "#003d4c",
        fontFamily: "Lato-Regular",
        fontWeight: "bold",
        fontSize: "50px",
      },

      footerText: {
        fontFamily: "Lato-Regular",
        lineHeight: "1.4rem",
        fontSize: "0.9rem",
        color: "#fff",
        letterSpacing: 0.7,
      },

      h1LatoHeavy: {
        fontSize: "25px",
        fontFamily: "Lato-Heavy",
        color: "#083d4c",
        letterSpacing: "0.75px",
      },
      h2LatoHeavy: {
        fontSize: "22px",
        fontFamily: "Lato-Heavy",
        letterSpacing: "0.66px",
        color: "#083d4c",
      },
      h2LatoHeavyNew: {
        fontSize: "22px",
        fontFamily: "Lato-Heavy",
        letterSpacing: "0.66px",
        color: `${greenThree}`,
      },
      h4LatoHeavy: {
        fontSize: "16px",
        fontFamily: "Lato-Heavy",
        color: "#003d4c",
      },
      h1LatoMedium: {
        fontSize: "18px",
        fontFamily: "Lato-Medium",
        color: "#607277",
      },
      h2LatoMedium: {
        fontSize: "16px",
        fontFamily: "Lato-Medium",
        color: "#607277",
      },
      h2LatoMediumNew: {
        fontSize: "16px",
        fontFamily: "Lato-Medium",
        color: `${greenThree}`,
      },
      h3LatoMedium: {
        fontSize: "15px",
        fontFamily: "Lato-Medium",
        color: "#607277",
      },
      h4LatoMedium: {
        fontSize: "14px",
        fontFamily: "Lato-Medium",
        color: "#607277",
      },
      h1LatoSemiBold: {
        fontFamily: "Lato-Semibold",
        color: "#003d4c",
        fontSize: "20px",
      },
      h2LatoSemiBold: {
        fontFamily: "Lato-Semibold",
        color: "#003d4c",
        fontSize: "18px",
        letterSpacing: "0.54px",
      },
      h3LatoSemiBold: {
        fontFamily: "Lato-Semibold",
        color: "#003d4c",
        fontSize: "16px",
        letterSpacing: "0.4px",
      },
      latoSemiBoldItalic: {
        fontFamily: "Lato-SemiBoldItalic",
        fontSize: "70px",
        letterSpacing: "2.1px",
        color: "#083d4c",
        lineHeight: "24px",
      },
      latoBlackItalic: {
        fontFamily: "Lato-BlackItalic",
        color: "#003d4c",
        fontSize: "18px",
      },
      h1LatoBlack: {
        fontFamily: "Lato",
        color: "#083d4c",
        fontSize: "36px",
        letterSpacing: "1.08px",
      },
      h2LatoBlack: {
        fontFamily: "Lato",
        color: "#003D4C",
        fontSize: "28px",
        letterSpacing: "0.7px",
      },
      h2LatoBlackNew: {
        fontFamily: "Lato",
        color: `${greenThree}`,
        fontSize: "28px",
        letterSpacing: "0.7px",
      },
      h3LatoBlack: {
        fontFamily: "Lato",
        color: "#003D4C",
        fontSize: "20px",
        letterSpacing: "0.4px",
      },
      h3LatoBlackNew: {
        fontFamily: "Lato",
        color: `${greenThree}`,
        fontSize: "20px",
        letterSpacing: "0.4px",
      },
      h4LatoBlack: {
        fontFamily: "Lato",
        color: "#083d4c",
        fontSize: "18px",
        letterSpacing: "1.01px",
      },
      h5LatoBlack: {
        fontFamily: "Lato",
        color: "#083d4c",
        fontSize: "16px",
      },
      h1LatoBold: {
        fontFamily: "Lato-Bold",
        color: "#003D4C",
        fontSize: "24px",
      },
      h2LatoBold: {
        fontFamily: "Lato-Bold",
        color: "#003D4C",
        fontSize: "20px",
      },
      h3LatoBold: {
        fontFamily: "Lato-Bold",
        color: "#003D4C",
        fontSize: "18px",
      },
      h3LatoBoldNew: {
        fontFamily: "Lato-Bold",
        color: `${greenThree}`,
        fontSize: "18px",
      },
      h4LatoBold: {
        fontFamily: "Lato-Bold",
        color: "#003D4C",
        fontSize: "16px",
      },
      h5LatoBold: {
        fontFamily: "Lato-Bold",
        color: "#003D4C",
        fontSize: "13px",
      },
      h6LatoBold: {
        fontFamily: "Lato-Bold",
        color: "#003D4C",
        fontSize: "6px",
      },
      h1LatoRegular: {
        fontFamily: "Lato-Regular",
        color: "#003D4C",
        fontSize: "20px",
      },
      h2LatoRegular: {
        fontFamily: "Lato-Regular",
        color: "#003D4C",
        fontSize: "18px",
      },
      h3LatoRegular: {
        fontFamily: "Lato-Regular",
        color: "#003D4C",
        fontSize: "16px",
      },
      h3LatoRegularNew: {
        fontFamily: "Lato-Regular",
        color: `${greenThree}`,
        fontSize: "16px",
      },
      h4LatoRegular: {
        fontFamily: "Lato-Regular",
        color: "#003D4C",
        fontSize: "14px",
      },
      h5LatoRegular: {
        fontFamily: "Lato-Regular",
        color: "#003D4C",
        fontSize: "11px",
      },
      h6LatoRegular: {
        fontFamily: "Lato-Regular",
        color: "#003D4C",
        fontSize: "17px",
      },
    },
  };
  return theme;
}
export default ThemeConfig;
